import PatchAdminConfigMessages from './PatchAdminConfigMessages'

export default PatchAdminConfigMessages
